import { AuthenticationService } from './../../Login/_services/authentication.service';
import { ClassicType } from './../../shared/models/ClassicType';
import { Filtri_Spedizione } from './../Models/Filtri_Spedizione';
import { Spedizione } from './../Models/Spedizione';
import { SpedizioniStoreService } from './../_services/spedizioni-store.service';
import { ApiRestService } from './../_services/api-rest.service';
import { Component, Input, OnInit, Output } from '@angular/core';
import { ServerPaginationService } from 'src/app/shared/_services/server-pagination.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Corriere } from '../Models/Corriere';
import { environment } from 'src/environments/environment';
import {ToastrService} from "ngx-toastr";
import {Permission} from "../../Login/_guards/Permission";
import {DownloadService} from "../../shared/_services/download.service";

@Component({
  selector: 'app-pratiche',
  moduleId: module.id,
  templateUrl: 'pratiche.component.html',
  styleUrls: ['pratiche.component.scss']
})
export class PraticheComponent implements OnInit{
  corrieredropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    textField: 'nominativo',
    allowSearchFilter: false,
    allowRemoteDataSearch: false,
  };
  statidropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    textField: 'label',
    idField: 'id',
    allowSearchFilter: false,
    allowRemoteDataSearch: false,
  };
  nuovi:number = 0;
  lavorare: number = 0;
  ldv: number = 0;
  inlineclick: boolean = true;
  corrieri: Corriere[] = [];
  stati: ClassicType[] = [];
  corrierisel: Corriere[] = [];
  statisel: ClassicType[] = [];
  titolo = environment.SpedizioniLabel;
  totaleCorriere: number = 0;
  totaleMargine: number = 0;
  totaleImporto: number = 0;
  statoTutti: boolean = false;
  statospedire: boolean = false;
  statolavorare: boolean = false;
  statoDareCorriere: boolean = false;
  statoDareAgenzia: boolean = false;
  @Input() isAddEnabled: boolean = true;
  @Input() isEditEnabled: boolean = true;
  hasFilter:boolean = true;
  collectionSize: number = 0;
  subscriptions: Subscription = new Subscription();
  Spedizioni: Spedizione[] = [];
  Selected: Spedizione;
  isAdmin: boolean = false;
  isAgenziaMadre: boolean = false;
  Filtri: Filtri_Spedizione = new Filtri_Spedizione(1,10);
  page = 1;
  pageSize = 50;
  pagesizeserver = 4 // pagine da precaricare da lserver
  newpagegenerated = 0; // pagina per cui è stata fatta la richiesta al server

  isMasterSel: boolean;

  constructor(
    private ApiRestService: ApiRestService,
    private spedizioniStore: SpedizioniStoreService,
    private paginationService: ServerPaginationService,
    private route: ActivatedRoute,
    private router: Router,
    private toastService: ToastrService,
    public AuthenticationService: AuthenticationService,
    public permission: Permission,
    private downloadService: DownloadService,
  ) {
    if(localStorage.getItem("inlineclick"))
      this.inlineclick = localStorage.getItem("inlineclick") == "YES";
    else
      localStorage.setItem("inlineclick", "YES");
    this.isAdmin = this.AuthenticationService.currentUserValue.ruoliObject.findIndex(x => x.id == "A" || x.id == "SA") > -1;
    this.isAgenziaMadre = this.AuthenticationService.currentUserValue.ruoliObject.findIndex(x => x.id == "AF") > -1;
    this.spedizioniStore.getCorrieri();
    this.subscriptions.add(this.spedizioniStore.$corrieri.subscribe(data => this.corrieri = data));
    this.subscriptions.add(this.spedizioniStore.$spedizioni.subscribe(data => {
      if (data && data != null) {
        this.collectionSize = data.total;
        this.nuovi = data.nuovi;
        this.lavorare = data.lavorare;
        this.Spedizioni = data.data;
        this.ldv = data.ldv;
      }
    }))
    this.subscriptions.add(this.ApiRestService.getStati().subscribe(data => this.stati = data));
    this.refreshTable(1)
  }
  ngOnInit() {
    this.Filtri.pratiche = true
  }

  sendsms(item?: Spedizione){
    if((!item.smsD || !item.smsM ) && this.permission.isPermitted('invio-sms'))
    this.ApiRestService.inviaSMS({ids: [item.id]}).subscribe(
      () =>{
        this.toastService.success("SMS inviati correttamente",  "YOOOOO!!" );
        this.refreshTable(1);
      }
    )
  }
  Edit(item?: Spedizione,isinline?:boolean) {
    var link = item ? 'spedizioni/edit/'+ item?.id?.toString(): 'spedizioni/edit';
    if (!isinline || (isinline && this.inlineclick))
        this.router.navigate([this.route.snapshot.queryParams[link] || link]);
  }
  EditNewTAb(item?: Spedizione) {
    if (item)
      this.router.navigate([]).then(result => {  window.open('spedizioni/edit/'+ item.id.toString(),"_blank"); });
  }
  delete(item: Spedizione) {
    if (confirm("Sei sicuro di voler eliminare questo elemento?"))
      this.ApiRestService.deleteSpedizione({ id: item.id }).subscribe(() => this.refreshTable(1));
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page: number) {
    this.Filtri.pratiche = true
    console.log('pagina generata', this.newpagegenerated)
    this.Filtri.size = this.pagesizeserver * this.pageSize;
    this.Filtri.page = (page - 1) / this.pagesizeserver + 1;

    this.spedizioniStore.getSpedizioni(this.Filtri);
  }
  corriereSelezionato(item: Corriere){

    if(this.corrierisel && this.corrierisel!= null && this.corrierisel.length>0 )
      this.Filtri.corriere = this.corrierisel[0].id;
    else
      this.Filtri.corriere = undefined;
  }
  statoSelezionato(item: ClassicType){
    this.statospedire = false;
    this.statolavorare = false;
    if(this.statisel && this.statisel!= null && this.statisel.length>0 ){
      this.Filtri.stato = this.statisel[0].id;
      this.statospedire = this.statisel[0].id == "DS" ;//&& !this.isAdmin;
      this.statolavorare = this.statisel[0].id == "DL" ;//&& !this.isAdmin;
      this.statoDareCorriere = this.statisel[0].id == "PC" ;
      this.statoDareAgenzia = this.statisel[0].id == "PF";
    }
    else
      this.Filtri.stato = undefined;
  }
  onFilterChange(){
    this.refreshTable(1)
  }
  inviaSMSSelezionati(){
    var selected: Spedizione[] = this.Spedizioni.filter(x => x.isSelected && (!x.smsD && !x.smsM));
    var ids: number[] = [];
    selected.forEach(element=> ids.push(element.id));
    if(ids && ids.length > 0)
      this.ApiRestService.inviaSMS({ids: ids}).subscribe(() => {
        this.toastService.success("SMS inviati correttamente",  "YOOOOO!!" );
        this.refreshTable(1);
      });
    else
      this.toastService.warning("Selezionare almeno una spedizione",  "HEII!!" );
  }
  spedisci(){
    var selected: Spedizione[] = this.Spedizioni.filter(x => x.isSelected);
    var ids: number[] = [];
    selected.forEach(element=> ids.push(element.id));
    this.ApiRestService.spedisci({ids: ids}).subscribe(() => this.refreshTable(1));
  }
  spedire(){
    var selected: Spedizione[] = this.Spedizioni.filter(x => x.isSelected);
    var ids: number[] = [];
    selected.forEach(element=> ids.push(element.id));
    this.ApiRestService.spedire({ids: ids}).subscribe(() => this.refreshTable(1));
  }
  paga_Coriere(){
    var selected: Spedizione[] = this.Spedizioni.filter(x => x.isSelected);
    var ids: number[] = [];
    selected.forEach(element=> ids.push(element.id));
    this.ApiRestService.pagaCorriere({ids: ids}).subscribe(() => this.refreshTable(1));
  }
  paga_Cliente(){
    var selected: Spedizione[] = this.Spedizioni.filter(x => x.isSelected);
    var ids: number[] = [];
    selected.forEach(element=> ids.push(element.id));
    this.ApiRestService.pagaCliente({ids: ids}).subscribe(() => this.refreshTable(1));
  }
  TotaleCorriereSelezionato(){
    var selected: Spedizione[] = this.Spedizioni.filter(x => x.isSelected);
    this.totaleCorriere = 0;
    selected.forEach(element => { this.totaleCorriere = this.totaleCorriere + (parseInt(element.costoCorriere)??0) });
  }
  TotaleAgenziaSelezionato(){
    var selected: Spedizione[] = this.Spedizioni.filter(x => x.isSelected);
    this.totaleMargine = 0;
    selected.forEach(element => { this.totaleMargine = this.totaleMargine + element.costoAgenzia });
  }
  TotaleimportiSelezionati(){
    var selected: Spedizione[] = this.Spedizioni.filter(x => x.isSelected);
    this.totaleImporto = 0;
    selected.forEach(element => { this.totaleImporto = this.totaleImporto + this.Totale(element) });
  }
  Totale(value: Spedizione) {
    var tot =
      (value.costoSpedizione || 0) +
      (value.costoContrassegno || 0) +
      (value.costoAssicurazione || 0) +
      (value.costoImballaggio || 0) +
      (value.t10 || 0) +
      (value.t12 || 0) +
      (value.costoPreavTel || 0) +
      (value.costoVarie || 0) +
      (value.costoTriangolazione || 0) +
      (value.costoDeposito || 0) +
      (value.costoConsegnaPiano || 0) +
      (value.costoRitiro || 0);
    return tot;

  }
  getTotali(){
    this.TotaleCorriereSelezionato();
    this.TotaleAgenziaSelezionato();
    this.TotaleimportiSelezionati();
  }
  checkUncheckAll() {
    for (var i = 0; i < this.Spedizioni.length; i++) {
      this.Spedizioni[i].isSelected = this.isMasterSel;
    }
    this.getTotali();
  }

  isAllSelected() {
    this.getTotali();
    this.isMasterSel = this.Spedizioni.every(function (item: any) {
      return item.isSelected == true;
    })
  }

  inlineclickChange() {
    if(this.inlineclick)
      localStorage.setItem("inlineclick","YES");
    else
      localStorage.setItem("inlineclick","NO");
  }
  stampamagnifest() {
    var selected: Spedizione[] = this.Spedizioni.filter(x => x.isSelected);
    var ids: number[] = [];
    selected.forEach(element=> ids.push(element.id));
    this.ApiRestService.stampaMagnifest({ids: ids}).subscribe((data) => {
        this.downloadService.downloadFile(data, "riepilogo.docx");
      }
    );
  }
}
